import { actions, selectors } from 'data'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import DepositModal from './DepositModal'

const Deposit = () => {
  const modalOptions = useSelector(selectors.app.getModalOptions)
  const dispatch = useDispatch()
  // track exit flow on unmount
  useEffect(() => {
    return () => {
      dispatch(
        actions.analytics.trackEvent({
          key: 'Deposit Flow Exited',
          properties: {}
        })
      )
    }
  }, [])
  return <DepositModal currency={modalOptions.currency} />
}

export default Deposit
